import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import Header from "./common/Header";
import Footer from './common/Footer';
import SEO from '../components/common/SEO';

const SearchResultsPage = () => {
    const [results, setResults] = useState({ doctors: [], hospitals: [] });
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    
    useEffect(() => {
        const fetchResults = async () => {
            const params = new URLSearchParams(location.search);
            const city = params.get('city') || '';
            const keyword = params.get('keyword') || '';
            
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/doctors/public/search?city=${city}&keyword=${keyword}`);
                if (res.data.success) {
                    setResults(res.data.data);
                }
            } catch (err) {
                console.error("Search API Error", err);
            } finally {
                setLoading(false);
            }
        };
        fetchResults();
    }, [location.search]);

    const DoctorCard = ({ doc }) => (
        <div className="card mb-4 shadow-sm border-0 p-3">
            <div className="row align-items-center">
                {/* Left: Image */}
                <div className="col-md-2 text-center">
                    <img 
                        src={doc.doctor_images?.[0]?.image_url || 'https://cdn-icons-png.flaticon.com/512/3774/3774299.png'} 
                        alt={doc.doctor_name}
                        className="rounded-circle img-fluid"
                        style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                        onError={(e) => {
                            e.target.src = 'https://cdn-icons-png.flaticon.com/512/3774/3774299.png';
                        }}
                    />
                </div>

                {/* Middle: Details */}
                <div className="col-md-6">
                    <h5 className="text-primary mb-1">{doc.doctor_name}</h5>
                    <p className="text-muted small mb-1"><i className="bi bi-geo-alt"></i> {doc.city}, {doc.state}</p>
                    <p className="mb-1"><strong>Speciality:</strong> {doc.speciality_names || 'General'}</p>
                    <p className="mb-1 text-success"><strong>Fees:</strong> ₹{doc.consultation_fees}</p>
                    <div className="mt-2">
                        <span className="badge bg-light text-dark border">
                            🕒 {doc.availability ? "Available" : "Consultation by Appointment"}
                        </span>
                    </div>
                </div>

                {/* Right: Contact Buttons */}
                <div className="col-md-4 border-start text-center">
                    <div className="d-grid gap-2">
                        <a href={`tel:${doc.phone_number}`} className="btn btn-outline-primary btn-sm">
                            📞 {doc.phone_number}
                        </a>
                        <a href={`https://wa.me/${doc.whatsapp_number}`} target="_blank" className="btn btn-outline-success btn-sm">
                            💬 WhatsApp
                        </a>
                        <a href={`mailto:${doc.doctor_email}`} className="btn btn-outline-secondary btn-sm text-truncate">
                            📧 {doc.doctor_email}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
            <SEO title="Medical Search Results | Mangoloops" description="Search for top-rated doctors and hospitals with Mangoloops. Find the best medical professionals and facilities tailored to your needs." />
            <Header />
            <div className="bg-light py-5 min-vh-100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <h3 className="mb-4">Search Results</h3>
                            
                            {loading ? (
                                <div className="text-center py-5">Loading results...</div>
                            ) : (
                                <>
                                    {/* Doctors List */}
                                    <section>
                                        <h4 className="text-muted mb-3">Doctors ({results.doctors.length})</h4>
                                        {results.doctors.length > 0 ? (
                                            results.doctors.map(doc => <DoctorCard key={doc.id} doc={doc} />)
                                        ) : <p>No doctors found.</p>}
                                    </section>

                                    {/* Hospitals List */}
                                    <section className="mt-5">
                                        <h4 className="text-muted mb-3">Hospitals ({results.hospitals.length})</h4>
                                        <div className="row">
                                            {results.hospitals.map(hosp => (
                                                <div className="col-md-6 mb-3" key={hosp.id}>
                                                    <div className="card h-100 shadow-sm p-3">
                                                        <h5 className="mb-1">{hosp.hospital_name}</h5>
                                                        <p className="text-muted small">{hosp.city}</p>
                                                        <button className="btn btn-primary btn-sm mt-auto">View Details</button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </section>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default SearchResultsPage;